import { render } from "./JieTiView.vue?vue&type=template&id=f314d7ca&scoped=true&ts=true"
import script from "./JieTiView.vue?vue&type=script&lang=ts"
export * from "./JieTiView.vue?vue&type=script&lang=ts"

import "./JieTiView.vue?vue&type=style&index=0&id=f314d7ca&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f314d7ca"]])

export default __exports__